<!--floorOverview 楼栋概览-->
<template>
  <div class="archiverstype">
    <div class="con">
      <floorTree @checkItem="checkItem2"></floorTree>
      <div class="right-table" v-if="typeEnum===2">
        <el-input style="width: 360px;" size="mini" placeholder="输入设备名称、设备ID、回路编号搜索" suffix-icon="el-icon-search"
          v-model="filterText2"> </el-input>
        <div class="num_box">
          <div class="t">
            <div class="num">1020</div>
            <div class="e">设备总数</div>
          </div>
          <div class="line"></div>
          <div class="t">
            <div class="num">864</div>
            <div class="e">设备开启数</div>
          </div>
          <div class="line"></div>
          <div class="t">
            <div class="num">278</div>
            <div class="e">设备关闭数</div>
          </div>
          <div class="line"></div>
          <div class="t">
            <div class="num">26</div>
            <div class="e">设备故障数</div>
          </div>
        </div>
        <div class="top-table">
          <div class="titles">
            <div class="leftd">
              <span>开启：</span>
              <div class="l1"></div><span>关闭：</span>
              <div class="l2"></div><span>故障：</span>
              <div class="l3"></div>
              <span>运行时长：</span>
              <div class="l1">8</div>
            </div>
          </div>

          <div class="center">
            <div class="ul">
              <div class="li" v-for="(item,e) in list" :key="e">
                <div class="name"><span>{{e+1}}楼</span></div>
                <div class="box_ul">
                  <div class="box_li" :style="{backgroundColor:chil.color}" v-for="(chil,i) in item.children" :key="i">
                    {{chil.num}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <floorCard v-if="typeEnum===0"></floorCard>
      <floorSpot v-if="typeEnum===1"></floorSpot>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elIconBtn from '@/components/module/iconBtns.vue'
  import floorSpot from './floorSpot.vue'
  import floorCard from './floorCard.vue'
  import floorTree from '@/components/module/tree/floorTree.vue'
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn,
      floorSpot,
      floorCard,
      floorTree
    },
    data () {
      return {
        value1: true,
        heights: Math.round((document.getElementById('app').clientHeight)*0.55),

        filterText: "",
        filterText2: "",

        list: [{
          name: '1楼',
          children: [{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 7,
            color: '#368ED9',
          },{
            num: 32,
            color: '#FF7A2F',
          },{
            num: '',
            color: '#E6E6E6',
          },{
            num: 7,
            color: '#368ED9',
          },]
        }],
        typeEnum: 2,

      }
    },

    mounted () {
      for(let i=0;i<5;i++) {
        this.list.push(this.list[0])

      }
    },
    methods: {
      goUrl (v) {
        this.typeEnum=v
      },
      checkItem2 (data) {
        console.log(data);
        if(data.typeEnum===0) {
          this.typeEnum=2
        } else {
          this.typeEnum=0
        }
      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },


    }
  }
</script>

<style scoped lang="scss">
  .ul {
    display: flex;
    flex-direction: column;
    border: 1px solid #e6e6e6;
    width: 100%;

    .li {
      display: flex;
      border-top: 1px solid #e6e6e6;

      .name {
        color: #1A1A1A;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 14px;
        width: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        background-color: #FBFBFB;
      }

      .box_ul {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        padding-top: 12px;

        .box_li {
          border-radius: 4px;
          background: #368ED9;
          width: 24px;
          height: 24px;
          margin-right: 12px;
          text-align: center;
          margin-bottom: 12px;
          line-height: 24px;
          color: #fff;
          font-size: 14px;
        }
      }
    }

    .li:nth-child(1) {
      border: none;
    }
  }

  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;

    .l1 {
      border-radius: 4px;
      background: #368ED9;
      width: 24px;
      height: 24px;
      margin-right: 20px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      font-size: 14px;
    }

    .l2 {
      border-radius: 4px;
      background: #E6E6E6;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .l3 {
      border-radius: 4px;
      background: #FF7A2F;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .rightd {
      border-radius: 4px;
      background: #FFF;
      border: 1px solid #E6E6E6;
      padding: 2px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .leftd {
      display: flex;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }

  .name-wrapper {
    position: absolute;
    width: 50px;
  }

  .spot img {
    position: absolute;
    width: .5rem;
    height: .5rem;
    left: 0;
    top: 0;
  }

  .center {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .num_box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    justify-content: space-around;
    margin-top: 20px;
    height: 66px;
    align-items: center;

    .line {
      width: 1px;
      height: 42px;
      background-color: #EBEBEB;
    }

    .num {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
      text-align: center;
    }

    .e {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;

    }
  }

  .custom-tree-node {
    display: flex;
    width: calc(100% - 51px);

    .tt {
      padding: 0px 5px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;

    }

    .aaa {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      align-items: center;
    }
  }

  .archiverstype {
    .con {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 8px;


      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 232px);
        min-height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px;


      }
    }
  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto;
  }

  .el-popover {
    padding: 0 !important;
    border-radius: 4px;
    overflow: hidden;
  }
</style>